import { memo } from 'react';
import { SKIP_LINK_TARGET } from '@/constants/accessibility';

/**
 * Skip Link Component
 * 
 * Provides a way for keyboard users to skip to the main content,
 * bypassing repetitive navigation elements.
 * 
 * This is essential for WCAG 2.1 Level A compliance.
 */
function SkipLinkComponent() {
  return (
    <a
      href={`#${SKIP_LINK_TARGET}`}
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 
                 focus:z-50 focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground
                 focus:rounded-md focus:font-medium focus:outline-none focus:ring-2 
                 focus:ring-ring focus:ring-offset-2"
    >
      Skip to main content
    </a>
  );
}

export const SkipLink = memo(SkipLinkComponent);
